import gqlTagGira from 'graphql-tag';
import { JWM_CATEGORY_OPTIONS_FRAGMENT } from '../../common/graphql/gql.tsx';

export const UPDATE_CATEGORY = gqlTagGira`
  mutation JwmUpdateCategory($input: JWMUpdateCategoryInput!) {
    updateJwmCategory(input: $input) {
      success
      errors {
        message
        extensions {
          errorType
          statusCode
        }
      }
      category {
        ...JwmCategoryOptionsFragment
      }
    }
  }
  ${JWM_CATEGORY_OPTIONS_FRAGMENT}
`;
